import {
  BANNER_DATA,
  TECHNICAL_SUPPORT,
} from '../../utils/const/products/vod-assessment';
import { useUserAgentInfo } from '../../context/user-agent';
import styles from '../../styles/common.module.scss';
import Styles from '../../components/productPageComponents/vodAssessment/index.module.scss';
import DetailBanner from '../../components/commonComponents/detailBanner';
import router from 'next/router';
import FadeIn from '../../components/commonComponents/fadeIn';
import TechnicalSupport from '../../components/commonComponents/technicalSupport';
import { Button, Row } from 'antd';
import VideoSceneList, {
  IVideoSceneConfig,
} from '../../components/productPageComponents/vodAssessment/VideoSceneList';
import CombineVideoPlayer from '../../components/productPageComponents/vodAssessment/CombineVideoPlayer';
import { useEffect, useState } from 'react';
import VideoInfoTable from '../../components/productPageComponents/vodAssessment/VideoInfoTable';
import BDRateChart from '../../components/productPageComponents/vodAssessment/BDRateChart';
import Assessment from '../../components/productPageComponents/vodAssessment/Assessment';
import { getVideoConfigs } from '../../services/products/vod-assessment';
import { getQueryVariable } from '../../utils/common';

const showBDRateNameList = ['短视频-UGC', '短视频-PGC'];
// const showTableInfoNameList = ['短视频-UGC', '短视频-PGC'];

export const getStaticProps = async (context) => {
  const res = await getVideoConfigs();
  return {
    props: { videoConfigs: res },
  };
};

/**
 *
 * @description 点播云客户价值评估工具
 */
const VodAssessment = ({ videoConfigs }) => {
  const { isMobile } = useUserAgentInfo();
  useEffect(() => {
    if (isMobile) {
      const mobileShow = getQueryVariable('mobileShow');
      if (!mobileShow) {
        router.replace(`/empty/transfer?returnTo=${window.location.href}`);
      }
    }
  }, []);

  const gotoVod = (): any => {
    window.open(`${process.env.NEXT_PUBLIC_VOD_BASE_URL}/`, '_blank');
  };
  // 视频场景配置
  const VideoSceneConfigs: IVideoSceneConfig[] = videoConfigs.map(
    (item, index) => {
      return {
        coverUrl: item.coverImgUrl,
        name: item.name,
        videoIndex: index,
        description: item.description,
      };
    }
  );

  // 视频播放
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const selectedVideoSceneChange = (val) => {
    setCurrentVideoIndex(val);
  };

  // 视频配置修改
  const defaultIndex = 0;
  function getBDRateData(index) {
    const videoConfig = videoConfigs[index];
    const BDRateRes = {
      common: videoConfig.sourceUrls.find((item) => item.type === 'common')
        ?.configs,
      zzql: videoConfig.sourceUrls.find((item) => item.type === 'zzql')
        ?.configs,
    };
    return BDRateRes;
  }
  useEffect(() => {
    const res = getBDRateData(currentVideoIndex);
    setBDRateData(res);
  }, [currentVideoIndex]);
  // 设置bd Rate

  const [BDRateData, setBDRateData] = useState(
    getBDRateData(currentVideoIndex)
  );

  const [sourceVideos, setSourceVideos] = useState([]);
  useEffect(() => {
    resetSourceVideos(currentVideoIndex);
  }, [currentVideoIndex]);
  const resetSourceVideos = (index) => {
    const temp = videoConfigs[index].sourceUrls.map((item, i) => {
      return {
        url: item.url,
        type: item.type,
        config: videoConfigs[index]?.combineVideo?.configs?.[i],
      };
    });
    setSourceVideos(temp);
  };

  return (
    <div className={styles.wrapper}>
      <DetailBanner bannerData={BANNER_DATA} mode="solution" onTry={gotoVod} />
      <div className={Styles.segmentationBackground}>
        <div className={styles.flexCenter}>
          <FadeIn>
            <VideoSceneList
              videoConfigs={VideoSceneConfigs}
              onVideoSelect={(index) => selectedVideoSceneChange(index)}
            />
          </FadeIn>
          <CombineVideoPlayer
            src={videoConfigs[currentVideoIndex].combineVideo.url}
            sourceVideos={sourceVideos}
          />
          {showBDRateNameList.includes(
            videoConfigs[currentVideoIndex].name
          ) && (
            <FadeIn>
              <div style={{ padding: '60px 0' }}>
                <Row justify="space-between" style={{ width: 1032 }}>
                  <VideoInfoTable
                    defaultIndex={defaultIndex}
                    style={{ width: 480 }}
                    sourceVideoConfigs={
                      videoConfigs[currentVideoIndex].sourceUrls
                    }
                    // onChange={tableInfoChange}
                  />
                  <BDRateChart data={BDRateData} />
                </Row>
              </div>
            </FadeIn>
          )}
        </div>
      </div>
      <div className={styles.linearBackground}>
        <div className={styles.flexCenter}>
          <FadeIn>
            <Assessment videoConfigs={videoConfigs} />
          </FadeIn>
        </div>
      </div>
      <TechnicalSupport
        title={TECHNICAL_SUPPORT.title}
        desc={TECHNICAL_SUPPORT.desc}
      >
        <div className={styles.flexCenterBtns}>
          <Button
            className={styles.opacityBtn}
            onClick={() => router.push('/form/consult/business-values')}
          >
            {TECHNICAL_SUPPORT.contactUs}
          </Button>
          <Button className={styles.primaryBtn} onClick={gotoVod}>
            {TECHNICAL_SUPPORT.tyrNow}
          </Button>
        </div>
      </TechnicalSupport>
    </div>
  );
};

export default VodAssessment;
